module.exports = __webpack_public_path__ + "img/p2-p2-diaoxiang.7d4f4092.png";